import { useForm } from 'react-hook-form';
import {
  ApplicantsFormDataValues,
  useApplicantsFormSchemaResolver,
} from './schema';
import { useApplicantsFormDefaultValues } from './defaultValues';
import { useApplicantsFormContext } from './context';
import { useEffect } from 'react';

export const useApplicantsForm = (applicationID: string) => {
  const formSchemaResolver = useApplicantsFormSchemaResolver(applicationID);
  const defaultValues = useApplicantsFormDefaultValues(applicationID);
  const { formControl } = useApplicantsFormContext(applicationID);

  const formMethods = useForm<ApplicantsFormDataValues>({
    defaultValues,
    values: defaultValues,
    resolver: formSchemaResolver,
    formControl,
    mode: 'all',
    reValidateMode: 'onChange',
    criteriaMode: 'all',
  });

  const { trigger } = formMethods;

  useEffect(() => {
    trigger();
  }, [trigger, defaultValues]);

  return formMethods;
};
